import appConfig from "../../../appconfig";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { getDeliveryMethodByNumberValue } from "../../../domains2/libraries/DeliveryMethods";
import { store } from "../../../store";
import {extractShopContext} from "../../../libraries/globalTemplateSpecific/bm100/utils";

const getEventName = (eventName) => {
	return eventName.includes(" ") ? eventName.split(" ").join("_") : eventName;
};

export const pushGTMExternal = async function(event, path_name, url) {
	if (appConfig.mobile.isMobileApp()) {
		await FirebaseAnalytics.logEvent({
			name: getEventName(event),
			params: {
				path_name,
				url
			}
		});
	}
	appConfig.googleTagManagerDataLayer.push({
		"event": event,
		"path_name": path_name,
		"url": url
	});
};

export const pushGTMInternal = async function(event, path_name, url, page_type, additionalData = {}) {

	const {shouldPushWeather, weatherData} = extractShopContext();

	const deliveryMethod = Number.isInteger(store.getters.tenantSpecificData.deliveryChoice)
		? getDeliveryMethodByNumberValue(store.getters.tenantSpecificData.deliveryChoice)
		: undefined;

	const shopName = store.getters.globalSelectedShop && store.getters.globalSelectedShop.shopNameAlias;
	const temperature = additionalData.temperature || (shouldPushWeather ? weatherData && weatherData.temperature	: undefined);
	const rain = additionalData.rain || (shouldPushWeather ? weatherData && weatherData.rain : undefined);

	if (appConfig.mobile.isMobileApp()) {
		await FirebaseAnalytics.logEvent({
			name: getEventName(event),
			params: {
				path_name,
				page_location: url,
				page_type,
				method: additionalData.method,
				user_id: additionalData.email && window.btoa ? window.btoa(additionalData.email) : undefined,
				selected_restaurant: shopName || additionalData.selectedRestaurant,
				chosen_delivery_method: deliveryMethod,
				star_count: additionalData.starCount,
				upsell_value: additionalData.upsellValue,
				temperature,
				rain,
				campaign_name: additionalData.campaignName
			}
		});
	}
	appConfig.googleTagManagerDataLayer.push({
		event: event,
		path_name: path_name,
		page_location: url,
		page_type: page_type,
		user_email: additionalData.email,
		method: additionalData.method,
		user_id: additionalData.email && window.btoa ? window.btoa(additionalData.email) : undefined,
		selected_restaurant: shopName || additionalData.selectedRestaurant,
		chosen_delivery_method: deliveryMethod,
		star_count: additionalData.starCount,
		upsell_value: additionalData.upsellValue,
		temperature,
		rain,
		campaign_name: additionalData.campaignName
	});
};
